import React from 'react';

const MinimalistLadyBug = (props) => {
  const { radius } = props;

  return (
    
    <svg width={`${radius * 2}px`} height={`${radius * 2.85}px`} x={`-${radius * 0.95}px`} y={`-${radius * 1.85}px`} viewBox="0 0 200 285" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Artboard" transform="translate(-5.000000, 0.000000)" fill="#343434">
            <g id="Group-2" transform="translate(5.000000, 0.000000)">
                <circle id="Oval-4" cx="95" cy="180" r="95"></circle>
                <circle id="Oval-4-Copy" cx="95" cy="85" r="50"></circle>
                <g id="Group" transform="translate(45.000000, 0.000000)">
                    <path d="M15.9513892,18.0370161 C18.4079106,16.2149681 20,13.2934103 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C10.0937229,20 10.1871447,19.9987107 10.2802486,19.9961488 L20.4027758,49.3941024 L26.0758872,47.4406934 L15.9513892,18.0370161 L15.9513892,18.0370161 Z" id="Combined-Shape"></path>
                    <path d="M88.9513892,18.0370161 C91.4079106,16.2149681 93,13.2934103 93,10 C93,4.4771525 88.5228475,0 83,0 C77.4771525,0 73,4.4771525 73,10 C73,15.5228475 77.4771525,20 83,20 C83.0937229,20 83.1871447,19.9987107 83.2802486,19.9961488 L93.4027758,49.3941024 L99.0758872,47.4406934 L88.9513892,18.0370161 L88.9513892,18.0370161 Z" id="Combined-Shape" transform="translate(86.037944, 24.697051) scale(-1, 1) translate(-86.037944, -24.697051) "></path>
                </g>
            </g>
          </g>
        </g>
    </svg>
  )
}
export default MinimalistLadyBug;

export function resize(props) {
  const {radius, minY, maxY} = props;

  return {
    ...props,
    minY: minY + radius * .85,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/minimalist/lady-bug.js